import { render, staticRenderFns } from "./cardMsg.vue?vue&type=template&id=0d9b3910&scoped=true"
import script from "./cardMsg.vue?vue&type=script&lang=js"
export * from "./cardMsg.vue?vue&type=script&lang=js"
import style0 from "./cardMsg.vue?vue&type=style&index=0&id=0d9b3910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b3910",
  null
  
)

export default component.exports